import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52915eec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-oc-bin-index" }
const _hoisted_2 = { class: "intro" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "button-wrapper" }

import { inject, computed, onMounted } from 'vue';
  import { ColorVariants } from '@/constants';
  import { authStore, ColletionBinStore } from '@/stores';
  import { useI18n } from 'vue-i18n';
  import { useRouter } from 'vue-router';
  import { request, alert, confirm, goToLogin } from '@/utils';
  import { IOfflineCollection } from '@/types/offline-collection';
  import _ from 'lodash';
  import { useToast } from 'bootstrap-vue-3';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const toast = useToast();
  const collectionBinStore = inject('collectionBinStore') as ColletionBinStore;

  const router = useRouter();
  async function handleStart() {
    if (!collectionBinStore.data.can_request_collection) {
      alert(collectionBinStore.data.request_collection_msg);
      return;
    }
    if (collectionBinStore.data.target?.collection_method === 'user_registration') {
      router.push({ name: 'offline_collections.bin.submit' });
    } else {
      router.push({ name: 'program.oc_qrcode', params: { id: collectionBinStore.data.program_id } });
    }
  }

  async function participate(id: number) {
    try {
      await request.post(`programs/${id}/participate`, {}, { loading: { silent: true } });
      collectionBinStore.fetchData();
      toast.show({ title: t('Success'), body: t('participate.join_success_content') }, { variant: ColorVariants.success });
    } catch (e) {
     toast.show({ title: t('Tips'), body: _.get(e, 'message') }, { variant: ColorVariants.warning });
    }
  }

  async function joinProgramConfirm() {
    if (!collectionBinStore.data.joined_program) {
      if (!authStore.isLogin) {
        const go = goToLogin();
        toast.show({ title: t('Tips'), body: t('Please login') }, { variant: ColorVariants.warning });
        go();
        return;
      }
      try {
        await confirm('', { content: t('participate.join_content') });
        participate(collectionBinStore.data.program_id);
      } catch (error) {
        router.push({ name: 'programs.show', params: { slug: collectionBinStore.data.program?.slug } });
        throw error;
      }
    }
  }

  onMounted(() => {
    joinProgramConfirm();
  });


  const target = computed(() => {
    return collectionBinStore.data.target as IOfflineCollection;
  });

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(target)?.description), 1),
    _createElementVNode("img", {
      src: _unref(target)?.image?.url,
      class: "image"
    }, null, 8, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_b_button, {
        pill: "",
        variant: _unref(ColorVariants).primary,
        onClick: handleStart
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('start')), 1)
        ]),
        _: 1
      }, 8, ["variant"])
    ])
  ]))
}
}

})